import { z } from "zod";
import { IsoDateString } from "./isoDate";

export const FileBase = z.object({
    id: z.string(),
    uploaded: IsoDateString,
    name: z.string().nullish(),
    displayName: z.string().nullish(),
    description: z.string().nullish(),
    sizeBytes: z.number().nullish(),
    type: z.string().nullish(),
    aiDescriptionShort: z.string().nullish(),
    aiDescriptionLong: z.string().nullish(),
    aiDescriptionStatus: z.enum(["PENDING", "DONE", "ERROR"]).nullish(),
    aiOptOut: z.boolean().nullish(),
});

export const PublicFile = FileBase.extend({
    visibility: z.literal("public"),
    url: z.string(), // CDN URL — use directly
});

export const PrivateFile = FileBase.extend({
    visibility: z.literal("private"),
    // No url — must call getDownloadUrl
});

export const FileEntry = z.discriminatedUnion("visibility", [PublicFile, PrivateFile]);

/** @deprecated Use FileEntry instead */
export const Document = FileBase;
